<div class="aria-offscreen skip-content-container bg-dark" id="skip_content">
  <a
    class="wrapper skip-main-content"
    href="#main_content"
    id="skip_main_content"
  >
    {{ label }}
  </a>
</div>
